var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from 'angular-ts-decorators';
import { asRequestBody } from '../../shared/util/as-request-body';
import { isValidEmail } from '../../shared/util/is-valid-email';
import { resetLoadingBtns, setLoadingBtn } from '../../shared/util/loading-button-util';
import { resetPassword, sendOneTimeLoginCode } from '../../shared/util/login-util';
let SendOneTimeLoginCodeController = class SendOneTimeLoginCodeController {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = [];
    constructor() { }
    hasValidEmail(email, e) {
        // Show error if no email is entered.
        if (!email || !isValidEmail(email)) {
            this.clearAllErrors();
            e.preventDefault();
            document.getElementById('invalidEmail').style.display = 'block';
            resetLoadingBtns();
            return false;
        }
        return true;
    }
    async onSendOneTimeCodeClicked(e) {
        if (e) {
            setLoadingBtn(e);
        }
        const formData = new FormData(document.getElementById('emailForm'));
        const body = asRequestBody(formData);
        const email = body.get('email') ?? '';
        if (!this.hasValidEmail(email, e)) {
            return;
        }
        try {
            // Will automatically redirect in case of success.
            await sendOneTimeLoginCode(body);
        }
        catch (error) {
            this.clearAllErrors();
            switch (error.message) {
                case 'INVALID_EMAIL':
                    document.getElementById('invalidEmail').style.display = 'block';
                    break;
                case 'MAGIC_CODE_LOGIN_DISABLED':
                    document.getElementById('loginDisabled').style.display = 'block';
                    this.updateUIBasedOnErrors();
                    break;
                case 'MAGIC_CODE_ALREADY_SENT':
                    document.getElementById('codeSentRecently').style.display = 'block';
                    break;
                default:
                    // Shouldn't really happen
                    console.error(error);
                    window.alert('UNEXPECTED_ERROR');
                    break;
            }
        }
        resetLoadingBtns();
    }
    resetInvalidEmailError() {
        document.getElementById('invalidEmail').style.display = 'none';
    }
    async onResetPasswordClicked(e) {
        if (e) {
            setLoadingBtn(e);
        }
        const formData = new FormData(document.getElementById('emailForm'));
        const body = asRequestBody(formData);
        const email = body.get('email') ?? '';
        if (!this.hasValidEmail(email, e)) {
            return;
        }
        await resetPassword(body);
        resetLoadingBtns();
    }
    navigateToLogin() {
        window.location.href = '/login' + window.location.search;
    }
    clearAllErrors() {
        for (const errorElementId of ['invalidEmail', 'loginDisabled', 'invalidState', 'codeSentRecently']) {
            const element = document.getElementById(errorElementId);
            if (!element) {
                console.error(`Element with id ${errorElementId} not found`);
                continue;
            }
            element.style.display = 'none';
        }
    }
    updateUIBasedOnErrors() {
        const descriptionElement = document.getElementById('description');
        const errorDescriptionElement = document.getElementById('errorDescription');
        const requestLoginCodeButton = document.getElementById('requestLoginCodeButton');
        const resetPasswordButton = document.getElementById('resetPasswordButton');
        if (descriptionElement && errorDescriptionElement) {
            descriptionElement.classList.add('hidden');
            errorDescriptionElement.classList.remove('hidden');
        }
        if (requestLoginCodeButton) {
            requestLoginCodeButton.style.display = 'none';
        }
        if (resetPasswordButton) {
            resetPasswordButton.classList.remove('btn-better-secondary');
            resetPasswordButton.classList.add('btn-primary');
        }
    }
};
SendOneTimeLoginCodeController = __decorate([
    Component({
        selector: 'app-send-one-time-login-code',
        // no associated template, is embedded static HTML-page in the server assets
    }),
    __metadata("design:paramtypes", [])
], SendOneTimeLoginCodeController);
export { SendOneTimeLoginCodeController };
